<script>
  /**
   * CSS class names to assign the button element.
   * @type {string}
   * @default ''
   */
  export let className = '';

  /**
   * Style or "kind" of the button to render.
   * Accepted values are 'primary', 'secondary', 'outline', and 'link'.
   * @type {string}
   * @default 'primary'
   */
  export let kind = 'primary';

  /**
   * Indicates whether the element is disabled.
   * @type {boolean}
   * @default false
   */
  export let disabled = false;

  /**
   * Type of button.
   * Accepted values are 'button', 'submit', or 'reset'.
   * @type {string}
   * @default 'button'
   */
  export let type = 'button';

  /**
   * A reference to the button DOM element
   * @type {Object}
   * @default null - which means no reference is set.
   */
  export let ref = null;

  /**
   * Defines the size of the button.
   * @type {string}
   * @default 'md' - typically means 'medium'.
   */
  export let size = 'md';
</script>

<button
  bind:this={ref}
  class="btn btn-{kind} btn-{size} {className}"
  aria-disabled={disabled}
  on:click
  {type}
  {disabled}
  {...$$restProps}
>
  <slot>Button</slot>
</button>

<style lang="scss" src="./button.scss"></style>
